// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCard_card__esOvb","image":"EventCard_image__OV0mw","timeAgo":"EventCard_timeAgo__BNUNF"};